import { centerAbs } from '../../../resources/styles';
import { merge } from '../../../utils';

const styles = {};

styles['container'] = { position: 'relative', width: 137, height: 137, borderRadius: 2, marginRight: 16, flexShrink: 0, overflow: 'hidden' };

styles['loader'] = merge(centerAbs, { pointerEvents: 'none' });

styles['retry'] = merge(centerAbs, { cursor: 'pointer', color: '#d32f2f', width: 32, height: 32 });

styles['image'] = { objectFit: 'cover', width: '100%', height: '100%' };

styles['delete'] = { position: 'absolute', top: 0, right: 0, cursor: 'pointer', color: '#d32f2f' };

export default styles;